import { FC } from "react";

import { copy } from "shared/assets";
import { Bus, Car, Plane, Train } from "shared/assets/icons";
import { Button, ButtonContainer } from "shared/components";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";

const travelLegCopy = copy.travelBlock.travelLeg;

interface Props {
  handleAddFlight: () => void;
  handleAddBus: () => void;
  handleAddTrain: () => void;
  handleAddGroundTransport: () => void;
}

export const AddTravelLegButtons: FC<Props> = ({
  handleAddFlight,
  handleAddBus,
  handleAddTrain,
  handleAddGroundTransport,
}) => {
  return (
    <ButtonContainer>
      <Button onClick={handleAddFlight} theme={ITheme.secondary} size="s">
        <Icon as={Plane} />
        <span>{travelLegCopy.buttons.addFlight}</span>
      </Button>
      <Button onClick={handleAddBus} theme={ITheme.secondary} size="s">
        <Icon as={Bus} />
        <span>{travelLegCopy.buttons.addBus}</span>
      </Button>
      <Button onClick={handleAddTrain} theme={ITheme.secondary} size="s">
        <Icon as={Train} />
        <span>{travelLegCopy.buttons.addTrain}</span>
      </Button>
      <Button onClick={handleAddGroundTransport} theme={ITheme.secondary} size="s">
        <Icon as={Car} />
        <span>{travelLegCopy.buttons.addGroundTransport}</span>
      </Button>
    </ButtonContainer>
  );
};
